import { Auth } from "aws-amplify";
import config from "../../config";
import { onPremSignOut } from "./on-prem-auth-service";
import { clearImpersonation } from "./impersonation-service";

const withScheme = (url) => (/^https?:\/\//.test(url) ? url : `http://${url}`);

export function getGoogleSignInUrl() {
  const params = new URLSearchParams({
    identity_provider: 'Google',
    client_id: config.COGNITO_APP_CLIENT,
    response_type: 'code',
    scope: 'aws.cognito.signin.user.admin email openid phone profile',
    redirect_uri: withScheme(config.COGNITO_AUTH_CALLBACK_URL),
  });
  return `https://${config.COGNITO_DOMAIN}/oauth2/authorize?${params.toString()}`;
}

export async function loadAuthUserInfo() {
  try {
    const authInfo = await Auth.currentAuthenticatedUser();
    if (authInfo) {
      return authInfo.attributes;
    } else {
      return null;
    }
  } catch (err) {
    console.debug('loadAuthUserInfo failed cause', err);
    return null;
  }
}

let redirectingToLogin = false;

// Clears the current session and sends the user back to the sign-in page.
export async function signOutAndRedirectToLogin() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  clearImpersonation();
  try {
    if (config.IS_ON_PREM) {
      onPremSignOut();
    } else {
      await Auth.signOut();
    }
  } catch (err) {
    console.debug('signOut failed cause', err);
  }
  window.location = '/signin';
}
